export default __webpack_public_path__ + "static/media/image-explore.ccbc2f82.png";